import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { routes } from '@app/app.routes';
import { provideFirebase } from '@core/firebase/firebase.providers';
import { FIREBASE_APP_CHECK } from '@core/firebase/firebase.tokens';
import { AuthStore } from '@auth/store/auth.store';
import { SaypStatementsStore } from '@save-as-you-pay/store/sayp-statements.store';
import { SaypStatementPdfsStore } from '@save-as-you-pay/store/sayp-statement-pdfs.store';
import { PdiAccountsStore } from '@customer/store/pdi-accounts.store';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideHttpClient(),
    provideCharts(withDefaultRegisterables()),
    provideFirebase(),
    provideAppInitializer(async () => {
      // All `inject()` calls must run synchronously — after `await`, the
      // initializer no longer runs in an injection context (NG0203).
      inject(FIREBASE_APP_CHECK); // Eagerly initialize App Check before any Firebase calls
      const authStore = inject(AuthStore);
      const statementsStore = inject(SaypStatementsStore);
      const statementPdfsStore = inject(SaypStatementPdfsStore);
      const pdiAccountsStore = inject(PdiAccountsStore);

      await authStore.initialize();
      statementsStore.streamAllStatements();
      statementPdfsStore.streamAllPdfs();
      pdiAccountsStore.streamAllAccounts();
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
  ],
};
